import { AxiosResponse } from "axios";
import { useEffect } from "react";
import { useContext, useState } from "react";
import { AdminFrame } from "views/common/AdminFrame";
import { getApiDataWithToken, postApiDataWithToken } from "views/utils/CallApi";
import { CtxAuth } from "views/utils/Contexts";
import * as mb from "views/common/MessageBox";
import Calendar from 'react-calendar';
import { dateToString8, getDateToString, stringToTime } from "views/utils/CommonFunc";

interface IFNonBusiness {
    "non_business_date": string
}

export function NonBusiness(): JSX.Element{

    const cua = useContext(CtxAuth);
    const [msgArgs, setMsgArgs] = useState({type:"", text:""});
    const [nonBusinessDateList, setNonBusinessDateList] = useState<IFNonBusiness[]>([]);
    const [scheduleDateList, setScheduleDateList] = useState<string[]>([]);
    const [submitDisabled, setSubmitDisabled] = useState<boolean>(true);

    //画面ロード処理
    useEffect(function(){
        getApiDataWithToken('/management/schedule/getting/date',
            {},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        let non_business_date_list = res.data.non_business_date_list;
                        let scheduled_date_list = res.data.scheduled_date_list;
                        let tmpData:IFNonBusiness[] = [];
                        non_business_date_list.forEach(function(item:any){
                            tmpData.push({"non_business_date": item.non_business_date});
                        });
                        let tmpScheduleDate:string[] = [];
                        scheduled_date_list.forEach(function(schedule:any){
                            tmpScheduleDate.push(dateToString8(new Date(schedule.scheduled_date)));
                        });
                        setNonBusinessDateList(tmpData);
                        setScheduleDateList(tmpScheduleDate);
                        setSubmitDisabled(false);
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"画面のロードに失敗しました。"});
                }
            }
        );
        // eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);


    //非営業日設定
    function clickSubmit(){
        setSubmitDisabled(true);
        postApiDataWithToken('/management/schedule/change/date',
            {"non_business_date_list": nonBusinessDateList},
            cua.getToken(),
            function(res:AxiosResponse<any>){
                switch (res.status){
                    case 200:
                        setMsgArgs({type:mb.MSGBOX_TYPE_SUCCESS, text:"非営業日の設定が完了しました。"});
                        break;
                    default:
                        setMsgArgs({type:mb.MSGBOX_TYPE_ERROR, text:"非営業日の設定に失敗しました。"});
                }
                setSubmitDisabled(false);
            }
         );
    }
    
    // 日付クリック処理
    function clickDay(value :Date){
        //既に配列に格納されていたら削除、されていなければ追加
        let strDate = getDateToString(value);
        let idx = nonBusinessDateList.findIndex(({non_business_date}) => non_business_date === strDate);
        let tmpList = nonBusinessDateList.concat();
        if (idx > -1){
            tmpList.splice(idx, 1);
        } else {
            tmpList.push({"non_business_date": strDate});
        }
        setNonBusinessDateList(tmpList);
    }

    // 選択状態によるクラスを取得
    function getSelectedClass(value :Date):string{
        let strDate = getDateToString(value);
        let idx = nonBusinessDateList.findIndex(({non_business_date}) => non_business_date === strDate);
        if (idx > -1){
            return "is-selected";
        }
        return "";
    }

    //非活性状態を取得
    function getDisableStatus(date:Date):boolean {
        if (scheduleDateList.length > 0){
            if (scheduleDateList.includes(dateToString8(date))){
                return true;
            }
        }
        return false;
    }

    return (
        <AdminFrame>
            <div className="contents">
                <mb.MessageBox args={msgArgs}/>
                <h2 className="settings-title-h2">非営業日管理</h2>
                <div className="settings-wrap-short">
                    <div className="settings-block">
                        <h3 className="settings-title-h3">特別非営業日</h3>
                        <div className="settings-form">
                            <div className="form-row-comment">
                                非営業日にしたい日付を選択してください。<br/>
                                ※既に注文管理内の確定日時に使用されている日付は非営業日にできません。
                            </div>
                            <div className="form-row">
                                <Calendar 
                                    locale="ja-JP" 
                                    formatDay={function(locale, date){return date.getDate().toString()}} 
                                    onClickDay={function(date){clickDay(date)}}
                                    prevLabel={<span className="material-icons-round">navigate_before</span>} 
                                    nextLabel={<span className="material-icons-round">navigate_next</span>} 
                                    prev2Label={null} next2Label={null} 
                                    className={"calendar-admin-schedule"}
                                    minDetail={"month"}
                                    maxDetail={"month"}
                                    view={"month"}
                                    tileClassName={function({activeStartDate, date, view }){return getSelectedClass(date)}}
                                    tileDisabled={function({activeStartDate, date, view }){return getDisableStatus(date)}}
                                />
                            </div>
                        </div>
                    </div>
                    <div className="control-horizon control-between margin-tb-20">
                        <button className="btn-primary" onClick={clickSubmit} disabled={submitDisabled}>変更を保存</button>
                    </div>
                </div>
            </div>
        </AdminFrame>
    )
}